import styled from 'styled-components';

export const Wrapper = styled.span<{ large?: boolean }>`
  color: purple;
  font-size: ${(props) => (props.large ? '16px' : '12px')};
  font-weight: normal;
  background-image: linear-gradient(to left, var(--primary), purple);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const Icon = styled.span`
  position: relative;
  top: 1px;
`;
